
/////Payment Imports /////////
import React, { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import * as Sentry from "@sentry/react";
import { bookingIfCardSaved } from "../../store/actions/paymentActions";
import { getUserProfile } from "../../store/actions/userProfileActions";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import ModalComponent from "../Modals/Modal";
import { useSelector } from "react-redux";
import { FaStarOfLife } from "react-icons/fa";
import ArrowTooltips from "../../components/Booking/CustomTooltip";
import { applyCoupon } from "../../store/actions/couponAcrion";
import { removeCoupon } from "../../store/actions/couponAcrion";
import { useToaster } from "../../components/Toaster";
import AddPaymentMethod from "./AddPaymentMethod";

///////////////////////////////


const PaymentMethodSection = forwardRef(({
  type,
  userInfo,
  setShowPaymentMessage,
  setRequestButtonLoading,
  bookingTotalModel,
  refreshBookingTotalModel,


}, ref) => {


  const [showPromoInput, setShowPromoInput] = useState(Boolean(bookingTotalModel?.coupon));
  const [promoCode, setPromoCode] = useState(bookingTotalModel?.coupon || "");
  const { loginInfo } = useSelector((state) => state.loginReducer);
  const { showToast } = useToaster();


  //////////////// Payment Method Section Logics Start /////////////////////


  // dispatch redux actions
  const dispatch = useDispatch();
  // history for routing
  const history = useHistory();
  // state to restrict multipel clicks
  const [buttonClicked, setButtonClicked] = useState(false);
  const [cardComplete, setCardComplete] = useState(false);
  const [requestLoading, setRequestLoading] = useState(false);
  const [promoLoading, setPromoLoading] = useState(false);
  // State to open CC modal
  const [openCreditCardModal, setopenCreditCardModal] = useState(false);
  // State to open CC response modal
  const [openCreditCardResponseModal, setopenCreditCardResponseModal] =
    useState(false);

  // State to open Booking error modal
  const [openBookingErrorModal, setopenBookingErrorModal] = useState(false);
  //toggle for card window name
  const [firstNameToggle, setfirstNameToggle] = useState(true);
  //payment credentials
  const [fullName, setfullName] = useState("");
  const [bookNowClicked, setBookNowClicked] = useState(false);


  const toggleLoading = (val) => {

    setShowPaymentMessage(val);
    try {
      setRequestLoading(Boolean(val));
      if (typeof setRequestButtonLoading === "function") {
        setRequestButtonLoading(Boolean(val));
      }
    } catch (err) {
      console.log(err);
    }
  };
  // function to close CC modal
  const handleCloseCardModal = () => {
    try {
      setopenCreditCardModal(false);
      setfirstNameToggle(true);
      setButtonClicked(false);
      setBookNowClicked(false);
      toggleLoading(false);
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  };

  //form ID control
  const [formID, setformID] = useState("");


  // function to place order and make payment

  const handlePlaceOrder = () => {
    setBookNowClicked(true);

    if (!userInfo) {
      history.push("/Login");
      return;
    }

    const booking_id = localStorage.getItem("bookingId");

    try {
      if (userInfo?.hasCard && userInfo?.userCards?.length > 0) {
        // start loading for booking request
        toggleLoading(true);
        dispatch(
          bookingIfCardSaved(
            booking_id,
            type,
            history,
            toggleLoading,
            handleShowBookingErrorModal,
            3
          )
        );
      } else {
        // open add-card modal as part of booking flow; keep `bookNowClicked` = true
        setopenCreditCardModal(true);
      }
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
      toggleLoading(false);
    }
  };




  const handleShowCardAddedModal = () => {
    try {
      const email = userInfo?.email || loginInfo?.email;
      if (email) {
        // refresh the user profile in Redux (also updates localStorage)
        dispatch(getUserProfile(email));
      }
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
    // stop loading state and re-enable buttons
    setButtonClicked(false);
    toggleLoading(false);
    // close the add-card modal
    setopenCreditCardModal(false);
    // only open the Request Booking modal when this add happened during booking flow
    if (bookNowClicked) {
      setopenCreditCardResponseModal(true);
    }
  };

  // expose `handlePlaceOrder` to parent via ref
  useImperativeHandle(ref, () => ({
    handlePlaceOrder,
  }));

  const handleCloseCardAddedModal = () => {
    setopenCreditCardResponseModal(false);
    try {
      setBookNowClicked(false);
    } catch (err) {
      console.log(err);
    }
  };

  const handleShowBookingErrorModal = () => {
    // stop loading state on error as well
    setButtonClicked(false);
    toggleLoading(false);
    setopenBookingErrorModal(true);
  };

  const handleCloseBookingErrorModal = () => {
    setopenBookingErrorModal(false);
  };
  const applyCouponCode = async (couponCode) => {
    setPromoLoading(true);
    try {
      const visionReqId = Number(localStorage.getItem("visionReqId"));
      if (!visionReqId) {
        console.error("visionReqId missing");
        return;
      }

      const booking_id = localStorage.getItem("bookingId");

      const tokenPayload = {
        bookingId: booking_id,
        couponCode: couponCode,
        totalCharges: bookingTotalModel?.totalCharge ?? "0",
      };

      const response = await applyCoupon(tokenPayload);

      if (response?.isSuccess) {
        // Fetch updated booking
        if (typeof refreshBookingTotalModel === "function") {
          await refreshBookingTotalModel();
        }

        showToast({
          type: "success",
          message: "Coupon applied",
          duration: 2500,
        });
      }

    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "Failed to apply coupon.";

      showToast({
        type: "error",
        message: errorMessage,
        duration: 2500,
      });


    }
    finally {
      setPromoLoading(false);
    }
  };


  const removeCouponCode = async () => {
    setPromoLoading(true);
    try {
      // 1️⃣ Remove coupon API call
      const booking_id = localStorage.getItem("bookingId");
      const response = await removeCoupon(booking_id);

      if (response?.isSuccess) {
        await refreshBookingTotalModel();
        showToast({
          type: "info",
          message: "Coupon removed",
          duration: 2500,
        });

      }

    } catch (error) {
      console.error("Error removing coupon code:", error);
    } finally {
      setPromoLoading(false);
    }
  };




  useEffect(() => {
    try {
      let makeBtnClickable;

      if (buttonClicked) {
        makeBtnClickable = setTimeout(() => {
          setButtonClicked(false);
        }, 10000);
      }
      return () => clearTimeout(makeBtnClickable);
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  }, [buttonClicked]);

  useEffect(() => {
    try {
      let makeBookNowBtnClickable;

      if (bookNowClicked) {
        makeBookNowBtnClickable = setTimeout(() => {
          setBookNowClicked(false);
        }, 10000);
      }
      return () => clearTimeout(makeBookNowBtnClickable);
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  }, [bookNowClicked]);

  //////////////// Payment Method Section Logics EnD /////////////////////


  useEffect(() => {
    setPromoCode(bookingTotalModel?.coupon || "");
  }, [bookingTotalModel]);

  // keep promo input visible when booking model has a coupon; otherwise keep hidden by default
  useEffect(() => {
    try {
      setShowPromoInput(Boolean(bookingTotalModel?.coupon));
    } catch (err) {
      console.log(err);
    }
  }, [bookingTotalModel]);






  return (
    <>
      <div className="mt-[23.23px] ">
        <div className="flex gap-x-2 items-center mb-[15.29px]">
          <img
            src={userInfo?.userCards?.length === 0 ? "/SummaryIconsgreen.svg" : "/images/NewUiIcons/SummaryIcons2.svg"}
            alt="Payment method icon"
          />
          <p className={`text-[16px] font-bold ${userInfo?.userCards?.length === 0 ? "text-[#211F59]" : "text-[#7876A1]"}`}>Payment method</p>
        </div>

        <div className="ml-[26.32px]">



          {userInfo?.userCards?.length > 0 && (
            <div className="flex items-center bg-[#F6F6F6] border px-3 py-2 rounded gap-2 mb-3">
              {/* 12 icons in 3 groups of 4 */}
              {Array.from({ length: 12 }).map((_, i) => (
                <FaStarOfLife
                  key={i}
                  className={`text-gray-400 w-3 h-3 ${i % 4 === 3 ? 'mr-2' : ''}`}
                />
              ))}
              {/* Last 4 digits */}

              <ArrowTooltips text={"Don’t worry — we never store your card details. The last 4 digits are shown just to help you recognize your card."}>
                <span className="text-[#211F59] font-mono">{userInfo?.userCards?.[0]?.stripeCardLastFourDigits}</span>
              </ArrowTooltips>
            </div>
          )}




          <div
            onClick={() => {
              try {
                // explicit direct Add/Change action — clear booking flow flag
                setBookNowClicked(false);
              } catch (err) {
                console.log(err);
              }
              setopenCreditCardModal(true);
            }}
            className={`mb-3.5 flex gap-x-2 font-semibold  text-[14px] cursor-pointer`}>
            <img
              src={userInfo?.userCards?.length === 0 ? "/AddIcongreen.svg" : encodeURI("/Vision Agent Icons/Add Icon/Addiconpurple.svg")}
              alt="plus icon"
            />

            <span className={userInfo?.userCards?.length === 0 ? "text-[#211F59]" : "text-[#7876A1]"}>{userInfo?.userCards?.length > 0 ? "Use a Different Card" : "Add a new card"}</span>
          </div>


          <div className="mb-3.5">



            <button
              type="button"
              onClick={() => setShowPromoInput((s) => !s)}
              className={`flex gap-x-2 font-semibold text-[#7876A1] text-[14px] items-center`}
            >

              <img src={showPromoInput ? "/images/NewUiIcons/LightPurpleSub.svg" : "/images/NewUiIcons/AddIcon.svg"} alt="icon" />
              <span >Enter a promo code</span>
            </button>

            {showPromoInput && (
              <div className="relative mt-2 w-full">
                <input
                  aria-label="Promo code"
                  placeholder="Enter promo code"
                  value={promoCode}
                  onChange={(e) => {
                    try {
                      setPromoCode(e.target.value);
                    } catch (err) {
                      console.log(err);
                    }
                  }}
                  readOnly={Boolean(bookingTotalModel?.coupon)}
                  className="w-full bg-[#F6F6F6] rounded-[8px] h-[40px] px-3 pr-14
    border border-[#7876A1] text-[#211F59] outline-none
    focus:ring-1 focus:ring-[#7876A1] focus:border-[#7876A1]
    transition-all duration-200"
                />

                {bookingTotalModel?.coupon ? (
                  <button
                    type="button"
                    aria-label="Remove promo"
                    onClick={() => {
                      try {
                        removeCouponCode();
                      } catch (err) {
                        console.log(err);
                      }
                    }}
                    disabled={promoLoading}
                    aria-busy={promoLoading}
                    className="absolute right-2 top-1/2 -translate-y-1/2 bg-red-600 text-white text-[12px] px-2 py-[4px] rounded flex items-center justify-center"
                  >
                    {promoLoading ? (
                      <svg className="animate-spin h-3 w-3 mr-2 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                      </svg>
                    ) : null}
                    {promoLoading ? 'Removing...' : 'Remove'}
                  </button>
                ) : (
                  <button
                    type="button"
                    aria-label="Apply promo"
                    onClick={() => {
                      applyCouponCode(promoCode);
                    }}
                    disabled={promoLoading || !promoCode}
                    aria-busy={promoLoading}
                    className="absolute disabled:bg-slate-500 right-2 top-1/2 -translate-y-1/2 bg-[var(--primary)] text-white text-[12px] px-2 py-[4px] rounded flex items-center justify-center"
                  >
                    {promoLoading ? (
                      <svg className="animate-spin h-3 w-3 mr-2 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                      </svg>
                    ) : null}
                    {promoLoading ? 'Applying...' : 'Apply'}
                  </button>
                )}
              </div>
            )}
          </div>
          <div className="text-[#7876A1] text-[12px] font-normal">Cancel at no charge up to 24 hours in advance.</div>
        </div>

        <div
          style={{
            height: "1px",
            backgroundColor: "#7876A1",
            marginTop: "18.63px",
            marginBottom: "23.29px",
          }}
        />
      </div>


      {/* /////////// Payment Screen Modal Start /////////// */}

      <div>
        <ModalComponent
          text={
            "Card added successfully, click request now to proceed with your booking."
          }
          openState={openCreditCardResponseModal}
          closeFunction={handleCloseCardAddedModal}
          btnText1={"Request now"}
          btnClickFunc1={handlePlaceOrder}
          loader={requestLoading}
          btnText2={"Close"}
          btnClickFunc2={handleCloseCardAddedModal}
        />
        <ModalComponent
          text={"Something went wrong, please try again or contact our support."}
          openState={openBookingErrorModal}
          closeFunction={handleCloseBookingErrorModal}
          btnText1={"Contact Us"}
          btnClickFunc1={() => history.push("/ContactUs")}
          btnText2={"Close"}
          btnClickFunc2={handleCloseBookingErrorModal}
        />
        <div>
          <AddPaymentMethod
            open={openCreditCardModal}
            buttonClicked={buttonClicked}
            cardComplete={cardComplete}
            formID={formID}
            firstNameToggle={firstNameToggle}
            fullName={fullName}
            userInfo={userInfo}
            setfirstNameToggle={setfirstNameToggle}
            setfullName={setfullName}
            setformID={setformID}
            handleCloseCardModal={handleCloseCardModal}
            handleShowCardAddedModal={handleShowCardAddedModal}
            handleShowBookingErrorModal={handleShowBookingErrorModal}
            onCardChange={(e) => {
              try {
                setCardComplete(Boolean(e?.complete));
              } catch (err) {
                console.log(err);
              }
            }}
            submitWrapper={(cb, e) => {
              e.preventDefault();
              if (!buttonClicked) {
                toggleLoading(true);
                setButtonClicked(true);
                cb(e);
              }
            }}
          />


        </div>
      </div>
      {/* /////////// Payment Screen Modal End /////////// */}


    </>
  );
});

export default PaymentMethodSection;
